import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { NeoDepartamentosClienteDTO } from '../Model/neoDepartamentosClienteDTO';
import { NeoDeptCiudadClienteHistorialDTO } from '../Model/neoDeptCiudadClienteHistorialDTO';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

const API_URL = environment.apiLocalUrl + 'neoDepartamentosCliente';
@Injectable({
  providedIn: 'root',
})
export class DepartamentosClienteService {
  constructor(private _http: HttpClient) {}

  getDepartamentosCliente(): Observable<NeoDepartamentosClienteDTO[]> {
    return this._http.get<NeoDepartamentosClienteDTO[]>(API_URL).pipe(catchError(HandleHttpError));
  }

  getUbicacionesPorIdCliente(idNeoCliente): Observable<NeoDeptCiudadClienteHistorialDTO[]> {
    return this._http.get<NeoDeptCiudadClienteHistorialDTO[]>(
      `${API_URL}/neoCliente/${idNeoCliente}`).pipe(catchError(HandleHttpError));
  }

  getDepartamentosClientePorId(idDepartamentosCliente): Observable<NeoDepartamentosClienteDTO> {
    return this._http.get<NeoDepartamentosClienteDTO>(
      `${API_URL}/${idDepartamentosCliente}`).pipe(catchError(HandleHttpError));
  }

  saveDepartamentosCliente(
    departamentosCliente: NeoDepartamentosClienteDTO
  ): Observable<NeoDepartamentosClienteDTO> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post<NeoDepartamentosClienteDTO>(
      API_URL, departamentosCliente, { headers: headers }).pipe(catchError(HandleHttpError));
  }

  updateDepartamentosCliente(
    departamentosCliente: NeoDepartamentosClienteDTO
  ): Observable<NeoDepartamentosClienteDTO> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.put<NeoDepartamentosClienteDTO>(
      API_URL, departamentosCliente, { headers: headers }).pipe(catchError(HandleHttpError));
  }

  deleteDepartamentosCliente(idDepartamentosCliente): Observable<any> {
    return this._http.delete<any>(`${API_URL}/${idDepartamentosCliente}`).pipe(catchError(HandleHttpError));
  }

  /* Consulta todos las ubicaciones aliado */
  getUbicacionesGeneral() {
    return this._http.get(`${API_URL}/neoClientes/`).pipe(catchError(HandleHttpError));
  }

  cargarArchivo(body: any){
    return this._http.post(`${API_URL}/cargueArchivo`, body).pipe(catchError(HandleHttpError));
  }
}
